import React, { useEffect, useState } from "react";
import useHttp from "../../../../hook/use-http";
import NoData from "../../../Dashboard/Driveanalysis/NoData";
import ChartLoader from "../../../Dashboard/Driveanalysis/ChartLoader";
import { Chart } from "react-google-charts";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitalstates";
import WaterMark from "../../../Dashboard/DashboardMain/WaterMark";
import { BsZoomIn } from "react-icons/bs";
import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../../redux/userSlice";
import "chartjs-plugin-datalabels";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);
ChartJS.defaults.scale.grid.color = "white";
function ModeUtilization_Kratos({ apiend, gloablfilter }) {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [testLabels, settestLabels] = useState([]);
  const [LineContainerBody, setCssLineCont] = useState({
    height: "250px",
    width: "100%",
  });
  let defaultArr = [];
  let totObj = { label: "Range", data: [], fill: true, borderColor: "#5a86bf" };
  const [chartdata, setChartData] = useState({
    labels: [],
    datasets: [],
    options: {
      plugins: {
        datalabels: {
          display: false,
        },
        legend: {
          display: false, // Hide the legend
        },
        tooltip: {
          enabled: false, // Disable tooltip
        },
      },
      scales: {
        y: {
          title: {
            display: true,
            text: "Range",
          },
        },
        x: {
          title: {
            display: true,
            text: "Discharge Cycle",
          },
        },
      },
    },
  });

  function appyData(dataParam) {
    if (dataParam.length > 0) {
      let temp = [];
      for (let i = 0; i < dataParam.length; i++) {
        temp.push(i + 1);
        totObj.data.push(dataParam[i].fields.Range[0]);
      }
      defaultArr.push(totObj);

      let mpvingAvg = {
        label: "Moving Avg",
        data: [],
        fill: false,
        borderColor: "#00A6D6",
      };
      let array = totObj.data;
      let element = 0;
      for (let i = 0; i < array.length - 4; i++) {
        element =
          (array[i] +
            array[i + 1] +
            array[i + 2] +
            array[i + 3] +
            array[i + 4]) /
          5;
        mpvingAvg.data.push(element);
        element = 0;
      }

      let nullArr = [];
      for (let j = 0; j < totObj.data.length - mpvingAvg.data.length; j++) {
        nullArr.push(null);
      }
      let finalMovAvg = nullArr.concat(mpvingAvg.data);
      mpvingAvg.data = finalMovAvg;
      // defaultArr.push(mpvingAvg);

      const data = {
        labels: temp,
        datasets: defaultArr,
        options: {
          plugins: {
            datalabels: {
              display: false,
            },
            legend: {
              display: false, // Hide the legend
            },
            tooltip: {
              enabled: false, // Disable tooltip
            },
          },
          responsive: true,
          maintainAspectRatio: false,
          interaction: {
            mode: "index",
          },
          scales: {
            y: {
              grid: {
                display: true,
              },
              title: {
                display: true,
                text: "Range",
              },
            },
            x: {
              grid: {
                display: false,
              },
              title: {
                display: true,
                text: "Discharge Cycle",
              },
            },
          },
        },
      };
      setChartData(data);
    } else {
      setChartData({
        labels: [],
        datasets: [],
        options: {
          plugins: {
            datalabels: {
              display: false,
            },
            legend: {
              display: false, // Hide the legend
            },
            tooltip: {
              enabled: false, // Disable tooltip
            },
          },
          scales: {
            y: {
              title: {
                display: true,
                text: "Range",
              },
            },
            x: {
              title: {
                display: true,
                text: "Discharge Cycle",
              },
            },
          },
        },
      });
    }
  }

  const options = {
    colors: ["#83A4CF", "#ffa650", "#72d817"],

    sliceVisibilityThreshold: 0,
  };

  useEffect(() => {
    fetchData(
      { url: API_URL_MAIN + apiend, body: { filterdata: gloablfilter } },
      appyData
    );
  }, [gloablfilter]);
  const loggedInUser = useSelector(selectLoggedInUser);

  return (
    <>
      <div
        className="modal fade"
        id="line_chart"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Discharge cycles vs Range
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body" style={{ height: "300px" }}>
              <div style={LineContainerBody} className="LineContainerBody">
                {isLoading ? (
                  <ChartLoader />
                ) : chartdata.datasets.length === 0 ? (
                  <NoData />
                ) : (
                  <Line
                    data={chartdata}
                    options={chartdata.options}
                    height={400}
                    width={1500}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="chartHGT">
        <strong
          className="align-top-chng"
          style={{ float: "right", cursor: "pointer", marginRight: "10px" }}
          data-bs-toggle="modal"
          data-bs-target={"#line_chart"}
        >
          {" "}
          <BsZoomIn />{" "}
        </strong>

        <WaterMark />
        {loggedInUser.flagForHideShow === "ERC" ? (
          <div style={LineContainerBody} className="LineContainerBody">
            {isLoading ? (
              <ChartLoader />
            ) : chartdata.datasets.length === 0 ? (
              <NoData />
            ) : (
              <Line
                data={chartdata}
                options={chartdata.options}
                height={350}
                width={400}
              />
            )}
          </div>
        ) : (
          <div style={LineContainerBody} className="LineContainerBody">
            {isLoading ? (
              <ChartLoader />
            ) : chartdata.datasets.length === 0 ? (
              <NoData />
            ) : (
              <Line data={chartdata} options={chartdata.options} />
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default ModeUtilization_Kratos;
